import React from 'react';
import { Card, Flex, Text, Badge, Button } from '@aws-amplify/ui-react';

function MeetingCard({ item, isSelected, onClick, onDelete }) {
  const getStatusInfo = () => {
    if (item.meeting_summary) return { icon: '🟢', text: 'Ready', color: 'success' };
    if (item.transcription_text) return { icon: '🟡', text: 'Processing', color: 'warning' };
    return { icon: '🔴', text: 'Uploaded', color: 'info' };
  };

  const getMeetingType = () => {
    const name = item.object_name.toLowerCase();
    if (name.includes('standup') || name.includes('daily')) return '📅';
    if (name.includes('1:1') || name.includes('one-on-one')) return '👥';
    if (name.includes('review') || name.includes('retrospective')) return '🔍';
    return '📞';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 1) return 'Today';
    if (diffDays === 2) return 'Yesterday';
    if (diffDays <= 7) return `${diffDays - 1}d ago`;
    
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric'
    });
  };

  const status = getStatusInfo();
  const getFileName = () => {
    // Extract filename from S3 path (e.g., "2025/Aug/2025-08-20/filename.mp3" -> "filename.mp3")
    const parts = item.object_name.split('/');
    const filename = parts[parts.length - 1];
    // Remove file extension for cleaner display
    return filename.replace(/\.[^/.]+$/, '');
  };

  const fileName = getFileName();

  const getSummarySnippet = () => {
    if (!item.meeting_summary) return null;
    const summary = item.meeting_summary.replace(/^#.*$/gm, '').replace(/\*/g, '').trim();
    return summary.substring(0, 80) + (summary.length > 80 ? '...' : '');
  };

  const summarySnippet = getSummarySnippet();

  return (
    <Card
      padding="0.75rem"
      style={{
        cursor: 'pointer',
        border: isSelected ? '2px solid #007EB9' : '1px solid #e0e0e0',
        backgroundColor: isSelected ? '#f0f8ff' : 'white',
        transition: 'all 0.2s ease',
        boxShadow: isSelected ? '0 2px 8px rgba(0, 126, 185, 0.15)' : 'none'
      }}
      onClick={onClick}
      className="meeting-card"
    >
      <Flex direction="column" gap="0.5rem">
        <Flex justifyContent="space-between" alignItems="flex-start">
          <Flex alignItems="center" gap="0.4rem" flex="1">
            <Text fontSize="1rem">{getMeetingType()}</Text>
            <Text fontSize="0.85rem" fontWeight="600" style={{ wordBreak: 'break-word', lineHeight: '1.3' }}>
              {fileName}
            </Text>
          </Flex>
          <Button
            size="small"
            variation="link"
            onClick={(e) => { e.stopPropagation(); onDelete(item); }}
            style={{
              minWidth: '24px',
              fontSize: '1.2rem',
              padding: '0.2rem',
              marginLeft: '0.3rem',
              color: '#666',
              opacity: 0.6
            }}
          >
            ×
          </Button>
        </Flex>

        {summarySnippet && (
          <Text fontSize="0.7rem" color="gray" style={{ lineHeight: '1.4', marginTop: '-0.2rem' }}>
            {summarySnippet}
          </Text>
        )}

        <Flex justifyContent="space-between" alignItems="center">
          <Flex alignItems="center" gap="0.3rem">
            <Text fontSize="0.7rem">{status.icon}</Text>
            <Badge size="small" variation={status.color} style={{ fontSize: '0.65rem', padding: '0.15rem 0.4rem' }}>
              {status.text}
            </Badge>
          </Flex>
          <Text fontSize="0.65rem" color="gray" fontWeight="500">
            {formatDate(item.last_updated)}
          </Text>
        </Flex>
      </Flex>
    </Card>
  );
}

export default MeetingCard;